import { HTMLProps } from 'react';

export default function IndeterminateCheckbox({
  indeterminate,
  className = '',
  checked,
  onChange,
  disabled,
  ..._rest
}: { indeterminate?: boolean } & HTMLProps<HTMLInputElement>) {
  const handleClick = () => {
    if (disabled) return;
    if (onChange) {
      // Create a synthetic event
      const syntheticEvent = {
        target: { checked: !checked },
        currentTarget: { checked: !checked },
      } as React.ChangeEvent<HTMLInputElement>;
      onChange(syntheticEvent);
    }
  };

  return (
    <>
      {/* Hidden input for form compatibility and accessibility */}
      <input
        type='checkbox'
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        style={{ display: 'none' }}
        aria-hidden='true'
      />

      {/* Custom visual checkbox */}
      <div
        className={className}
        onClick={handleClick}
        style={{
          width: '16px',
          height: '16px',
          border: '1px solid #dee2e6',
          borderRadius: '3px',
          backgroundColor: checked ? '#007bff' : '#ffffff',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          transition: 'background-color 0.08s ease',
          opacity: disabled ? 0.5 : 1,
          cursor: disabled ? 'not-allowed' : 'pointer',
        }}
      >
        {/* Checkmark */}
        {checked && (
          <svg
            width='10'
            height='8'
            viewBox='0 0 10 8'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              d='M1 4L3.5 6.5L9 1'
              stroke='#ffffff'
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </svg>
        )}

        {/* Indeterminate state */}
        {indeterminate && !checked && (
          <div
            style={{
              width: '8px',
              height: '2px',
              backgroundColor: '#007bff',
              borderRadius: '1px',
            }}
          />
        )}
      </div>
    </>
  );
}
